import * as React from 'react';
import { SVGProps } from 'react';

const SvgMyLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m17.27 6.73-4.24 10.13-1.64-4.25-.82-.32-3.43-1.33 10.13-4.23zM21 3 3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z" />
  </svg>
);

export default SvgMyLocation;
